<template>
    <main
        id="main"
        class="relative">
        <vue-headful
            :title="$page && $page.document_title ? `${$page.document_title} | Image Salon` : 'Image Salon'"
            :description="$page && $page.document_description ? $page.document_description : 'We are a global photography and post-production solution, powered by 70+ photographers and retouchers working together in Montreal, Canada.'"
        />
        <TisBanner
            v-if="$page && $page.banner"
            :banner="$page.banner" />
        <header class="relative">
            <tis-menu
                :config="$page.config"
                :menu="$page.menu"
                :contact="$page.contact"
                :services-categories="$page.servicesCategories"
                :locale="$page.locale" />
        </header>
        <slot />
        <footer>
            <tis-footer
                :footer="$page.footer"
                :contact="$page.contact"
                :external-links="$page.externalLinks"
                context="website"
            />
        </footer>
    </main>
</template>

<script>
import TisMenu from '@web/components/TisMenu';
import TisFooter from '@whisper/components/TisFooter';
import TisBanner from '@whisper/components/TisBanner';

export default {
  components: {
    TisBanner,
    TisMenu,
    TisFooter,
  },
};
</script>
